export const HU = {
  translation: {
    Header: {
      TITLE: "fejléc",
      AIM: "cukrász portfolió",
      ABOUT_ME: "bemutatkozás",
      SKILLS: "képességek",
      CAKES: "édességek",
      CONTACT: "kapcsolat",
      MAIN:"főoldal"
    },
    HomePage: {
      TITLE: "főoldal",
      Landing: {
        HELLO: "Üdvözöllek! Alexandra vagyok, elkötelezett",
        PATISSIER: "Cukrász",
        BRING_MAGIC:
          "Desszertek készítésekor mágiát viszek a tányérra, felejthetetlenné téve az édességeket. Kreativitással és szeretettel varázsolom el az ételeket, minden tányért lenyűgöző élménnyé alakítva."
      },
      AboutMe: {
        TITLE: "Bemutatkozás",
        INTRODUCTION:
          "Az életem olyan, mint egy többrétegű torta, ahol minden réteg egy szeletnyi szenvedélyt, kreativitást és folyamatos tanulást képvisel. A cukrászat nem csupán szakma számomra, hanem egy művészi kifejezési forma, ahol a képzeletem szárnyalhat, és ahol a finom ízek és formák által varázsolhatok mosolyt az emberek arcára. De a kreativitásom nem merül ki a konyhában; a festészet és a programozás adja a másik két alappillért.A tanulás iránti szeretetem vezérel abban, hogy folyamatosan bővítsem tudásomat és készségeimet. Mindig van mit tanulni – új receptek, festészeti technikák, programozási nyelvek –, és ez a tudáséhség tart éberen és motiváltan.A nyugodt, kiegyensúlyozott életvitel fontossága számomra olyan, mint a napsütés egy pihentető délutánon. Harmoniára törekszem mindennapjaimban, hogy környezetemmel és önmagammal is békében legyek. Ez a belső béke és egyensúly ad erőt és inspirációt nekem, hogy a legjobbamat nyújthassam mindenben, amit csinálok.Minden, amit csinálok, a szenvedély és a kreativitás jegyében történik.Az olvasás iránti szenvedélyem kalandozásokra hív egy másik világba, ahol a fantasy és sci-fi történetek mellett a szépirodalmi művek és tudományos ismeretek is helyet kapnak. Jelenleg az olasz nyelv tanulásával bővítem látókörömet, új kultúrákat és perspektívákat felfedezve. Ezek az értékek vezérlik életem minden aspektusát, lehetővé téve számomra, hogy a legteljesebb mértékben éljem meg minden egyes napot."
      },
      Skills:{
        HUN:'magyar',
        ENG:'angol',
        ITA:'olasz',
        GER:'német',
        HUN_LEV:'anyanyelv',
        ENG_LEV:'C2',
        ITA_LEV:'kezdő',
        COUNTER:{
          RECEIPES:'receptek',
          EXPERIENCE:'év tapasztalat',
          COUNTRIES:'ország desszertjei'
        },
        TECHNICAL_SKILLS:'Technikai Készségek',
        SOFT_SKILLS:'Személyes Tulajdonságok',
        LANGUAGES_SKILLS:'Nyelvi Készségek',
        TECHNICAL:[
          'Ismerem a különböző manapság népszerű sütési és termék készítési technológiákat ugyanúgy mint a klasszikus desszertek elkészítését.',
          'Különleges figyelmet fordítok az ízegyeztetésre, állandóan harmonikus ízkombinációkat hozok létre desszertjeimben. Minden desszertemet művészi módon tálalom, ahol a színek, textúrák és az egyensúly szem előtt tartásával vizuálisan vonzó kreációkat hozok létre.',
          'Továbbá, széles körben ismerem a tányér desszertek, kenyerek, péksütemények,fagylaltok, bonbonok, teasütemények, hideg előételek készítéséhez szükséges eszközöket és jártas vagyok különböző tálalási módszerek alkalmazásában a vendéglátóhely típusának és elvárásainak megfelelően.',
          'Az innováció kulcsfontosságú a munkamódszeremben - képes vagyok új péksütemény receptek kidolgozására, miközben a minőséget és következetességet előtérbe helyezem. Fontosnak tartom a szigorú higiéniai előírások betartását és az ételbiztonsági gyakorlatok elsőbbségbe helyezését a konyhában.'
        ],       
        SOFT:[
          'Kreativitás: Az új ízkombinációk, innovatív tálalási technikák és egyedi desszertkoncepciók folyamatos kutatása a szenvedélyem. Célom a vendégek, vásárlók elkápráztatása és az étteremi élményük fokozása.',
          'Rugalmasság: A gasztronómia dinamikusan és folyamatosan fejlődik. Elkötelezettséggel fogadom a változást, könnyedén alkalmazkodom az új trendekhez, hozzávalókhoz és technikákhoz, hogy lépést tartva javítsam a szakmámat.',
          'Együttműködés: Az együttműködés elengedhetetlen egy forgalmas konyhai környezetben. Kiválóan működöm csapatban, hatékonyan kommunikálok kollégáimmal, mindig szem előtt tartva feletteseim elvárásait és beosztottaim érdekeit, megosztom az ötleteimet, hogy összehangoltan dolgozhassunk a kulináris kiválóság elérése érdekében.',
          'Végül, célom, hogy emlékezetes élményeket nyújtsak az ügyfeleknek desszertjeimmel. Figyelmesen hallgatok az ügyfél visszajelzéseire, törekedve arra, hogy felülmúljuk az elvárásaikat, és minden édes alkotással maradandó benyomást keltsünk.'
        ],
        LANGUAGE:'Szeretek nyelveket tanulni, jelenleg olaszul tanulok illetve Python programnyelvet'
      },
      CakeTypeNav:{
        CAKES:'Torták',
        PLATED:'Tányér Desszertek',
        BONBON: 'BonBonok és Sütik'
      }
    },
    ProductPage: {
      TITLE: "sütik"
    },
    Footer: {
      LETS:"Legyen szó egy egyszerű beszélgetésről, vagy egy zseniális ötlet megosztásáról, vagy munkáról ne habozz felvenni velem a kapcsolatot. Kezdjük el a beszélgetést!",
      SITEMAP: {
        TITLE: "oldaltérkép",
        HOME: "főoldal",
        PRODUCTS: "sütik"
      }
    }
  }
};
